import { FC, useRef } from 'react';
import classNames from 'classnames/bind';
import InputGuests from 'src/common/components/Search/Inputs/InputGuests';
import PopoverGuests from 'src/common/components/Search/Popover/PopoverGuests';
import type { SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import type { SearchHeroVariant } from 'src/common/components/Search/types';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import styles from '../PopoverInputs.module.scss';

const cx = classNames.bind(styles);

type PopoverGuestsInputProps = {
  refs: SearchRefs;
  variant?: SearchHeroVariant;
  className?: string;
};

const PopoverGuestsInput: FC<PopoverGuestsInputProps> = ({ refs, variant, className }) => {
  const modal = useSearchHeroModalContext();
  const ref = useRef<HTMLDivElement>(null);
  return (
    <div className={className} ref={ref}>
      <InputGuests refs={refs} variant={variant} />
      <div className={cx(styles.popovers, `${variant}Variant`, { active: modal.active === 'guests' })}>
        <div className={styles.guests}>
          <PopoverGuests refs={refs} />
        </div>
      </div>
    </div>
  );
};

export default PopoverGuestsInput;
